<template>
    <footer id="contacts" class="bg-navy-gradient py-14">
        <div class="container mx-auto px-4">
            <div class="flex flex-col md:flex-row justify-between items-start gap-8">
                <div>
                    <div class="flex items-center gap-3">
                        <img v-if="brandLogo" :src="brandLogo" alt="" class="h-12 w-auto shrink-0" />
                        <!-- prefix и accent впритык (Vue condense убирает перенос между элементами);
                             пробел между ними — дело контента, например хвостовой в prefix -->
                        <span class="text-xl font-bold text-primary-foreground tracking-tight font-heading">
                            <span>{{ brandPrefix }}</span>
                            <span class="text-gradient-blue">{{ brandAccent }}</span>
                        </span>
                    </div>
                    <p v-if="description" class="text-primary-foreground/50 text-sm mt-1">{{ description }}</p>
                    <div v-if="companyLines.length" class="mt-4 space-y-1 text-primary-foreground/60 text-xs">
                        <p v-for="(line, i) in companyLines" :key="i">{{ line }}</p>
                    </div>
                </div>

                <div class="flex flex-col gap-2 text-sm">
                    <div v-if="address" class="flex items-start gap-2 text-primary-foreground/60">
                        <BlockIcon name="MapPin" :size="14" class="mt-0.5 shrink-0" />
                        <span>{{ address }}</span>
                    </div>
                    <a
                        v-if="phone"
                        :href="`tel:${phoneHref}`"
                        class="flex items-center gap-2 text-primary-foreground/70 hover:text-primary-foreground transition-colors"
                    >
                        <BlockIcon name="Phone" :size="14" />
                        {{ phone }}
                    </a>
                    <a
                        v-if="email"
                        :href="`mailto:${email}`"
                        class="flex items-center gap-2 text-primary-foreground/70 hover:text-primary-foreground transition-colors"
                    >
                        <BlockIcon name="Mail" :size="14" />
                        {{ email }}
                    </a>
                    <a
                        v-if="siteUrl"
                        :href="siteUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="text-accent hover:text-accent/80 transition-colors font-medium"
                    >
                        {{ siteLabel }}
                    </a>
                </div>

                <div v-if="gds.length" class="flex flex-wrap justify-center gap-6">
                    <div
                        v-for="(name, i) in gds"
                        :key="i"
                        class="flex items-center gap-2 text-primary-foreground/60 text-sm"
                    >
                        <BlockIcon name="Globe" :size="14" />
                        <span>{{ name }}</span>
                    </div>
                </div>
            </div>

            <div
                v-if="copyright || privacyUrl"
                class="mt-8 pt-6 border-t border-primary-foreground/10 text-center space-y-2"
            >
                <p v-if="copyright" class="text-primary-foreground/40 text-xs">{{ copyright }}</p>
                <p v-if="privacyUrl">
                    <a
                        :href="privacyUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="text-primary-foreground/40 hover:text-primary-foreground/70 text-xs underline transition-colors"
                    >
                        {{ privacyLabel }}
                    </a>
                </p>
            </div>
        </div>
    </footer>
</template>

<script>
import BlockIcon from "./BlockIcon.vue";
import { chromeDefaults } from "./chromeDefaults.js";

export default {
    name: "LandingFooter",
    components: { BlockIcon },
    props: { chrome: { type: Object, default: () => ({}) } },
    computed: {
        brandPrefix() {
            return this.chrome.brand_prefix ?? chromeDefaults.brand_prefix;
        },
        brandAccent() {
            return this.chrome.brand_accent ?? chromeDefaults.brand_accent;
        },
        // Без фолбэка на brand_logo: знак шапки рассчитан на светлый фон и на тёмном не виден.
        brandLogo() {
            return this.chrome.brand_logo_footer || "";
        },
        description() {
            return this.chrome.footer_description ?? chromeDefaults.footer_description;
        },
        companyLines() {
            return this.chrome.footer_company || [];
        },
        address() {
            return this.chrome.footer_address ?? "";
        },
        phone() {
            return this.chrome.footer_phone ?? "";
        },
        phoneHref() {
            return (this.phone || "").replace(/[^+\d]/g, "");
        },
        email() {
            return this.chrome.footer_email ?? "";
        },
        siteUrl() {
            return this.chrome.footer_site_url ?? "";
        },
        siteLabel() {
            return this.chrome.footer_site_label ?? this.siteUrl;
        },
        gds() {
            return this.chrome.footer_gds || [];
        },
        copyright() {
            return this.chrome.footer_copyright ?? "";
        },
        privacyUrl() {
            return this.chrome.footer_privacy_url ?? "";
        },
        privacyLabel() {
            return this.chrome.footer_privacy_label || chromeDefaults.footer_privacy_label;
        },
    },
};
</script>
